export var CoverageSortingCriteria;
(function (CoverageSortingCriteria) {
    CoverageSortingCriteria["BiggestAcceptedAmount"] = "biggest-accepted-amount";
    CoverageSortingCriteria["BiggestRefusal"] = "biggest-refusal";
    CoverageSortingCriteria["BiggestPartialAmountAbsolute"] = "biggest-partial-amount-absolute";
    CoverageSortingCriteria["BiggestPartialAmountRelative"] = "biggest-partial-amount-relative";
    CoverageSortingCriteria["IncomingReduction"] = "biggest-incoming-reduction";
    CoverageSortingCriteria["IncomingCancellation"] = "biggest-incoming-cancellation";
})(CoverageSortingCriteria || (CoverageSortingCriteria = {}));
